import { ModerationTable } from "@nwga/features/admin/ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/jobs")({
	component: AdminJobsPage,
});

function AdminJobsPage() {
	return (
		<div className="space-y-6">
			<div>
				<h1 className="font-semibold text-2xl tracking-tight">Listings</h1>
				<p className="mt-1 text-muted-foreground text-sm">
					Every listing on the platform, including drafts the public board never
					shows.
				</p>
			</div>

			<ModerationTable />
		</div>
	);
}
